import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";
import { CourseType } from "../../contracts/enums";

type ContextCourseData = {
    type: CourseType,
    setTypeCourse: (type: CourseType) => void
}

const DEFAULT_CONTEXT_DATA: ContextCourseData = {
    type: CourseType.chemistry,
    setTypeCourse: (type: CourseType) => { }

}

const CourseContext = createContext<ContextCourseData>(DEFAULT_CONTEXT_DATA);

export const CourseProvider = ({ children }: PropsWithChildren<any>) => {
    const [type, setType] = useState<CourseType>(CourseType.chemistry);

    const setTypeCurrent = useCallback((type: CourseType) => {
        setType(type);
    }, []);

    return (
        <CourseContext.Provider
            value={{
                type,
                setTypeCourse: setTypeCurrent,
            }} >
            {children}
        </CourseContext.Provider>
    );
};

export function useCourse(): ContextCourseData {
    const context = useContext(CourseContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}